module.exports = __webpack_public_path__ + "static/media/kerberos.b695118c.png";